const lang = {
  title_pages: {
    default: process.env.MIX_APP_NAME,
  },
  option: {
    gender: {
      male: '男性',
      female: '女性',
      other: 'その他',
    },
    living_area: {
      domestic: '国内',
      foreign: '国外',
    },
    have_tax_return: {
      false: 'していない',
      true: 'している',
    },
    yes_no_option: {
      none: 'なし',
      yes: 'あり',
    },
  },
  placeholder: {
    email: 'メールアドレス',
    password: 'パスワード',
    last_name: '姓',
    first_name: '名',
    last_name_kana: 'セイ',
    first_name_kana: 'メイ',
    prefecture: '都道府県',
    city: '市区町村',
    house_number: '番地',
    building_name: '建物名・部屋番号',
    selection: '選択',
  },
  back_to_top: '<< ホームに戻る',
  back_one_step: '<< 一つ前に戻る',
  home: 'ホーム',
  pagination: {
    button_first: '<<',
    button_prev: '<',
    button_next: '>',
    button_last: '>>',
  },
  year: '年',
  month: '月',
  day: '日',
  hour: '時',
  minute: '分',
  selection_year: '年',
  selection_month: '月',
  selection_day: '日',
  selection_hour: '時',
  selection_minute: '分',
  close_the_window: 'ウィンドウを閉じる',
  custom_column_names: {
    email: 'メールアドレス',
    password: 'パスワード',
    last_name: '姓',
    first_name: '名',
    last_name_kana: 'セイ',
    first_name_kana: 'メイ',
    prefecture: '都道府県',
    city: '市区町村',
    house_number: '番地',
    building_name: '建物名・部屋番号',
    phone_number: '電話番号',
    prefecture_id: '都道府',
    zip_code: '郵便番号',
    gender: '性別',
    birth_day: '生年月日',
    name: 'お名前',
    other_inquiry: 'その他お問い合わせ',
  },
  history: {
    operator_type: {
      system: 'システム自動更新',
      customer: '顧客本人',
    },
  },
  header: {
    return_home: 'ホームに戻る',
    return_department: '他の部署に切り替える',
    edit: 'アカウント情報の編集',
    logout: 'ログアウト',
    edit_modal: {
      title: 'アカウントの編集',
      form: {
        current_password: '現在のパスワード',
        new_password: '新しいパスワード',
        confirm_new_password: '新しいパスワード(確認)',
      },
    },
  },
  button: {
    clear_search_condition: '検索条件をクリアする',
    pick_template: '定型文を選択する',
    search: '検索',
    return_to_input: '入力に戻る',
    delete: '削除する',
    add_file: '＋ファイルを追加する',
    update: '更新する',
    to_add: '追加する',
  },
  cancel: 'キャンセル',
  input_string_name: {
    first_name: '　名',
    last_name: '　姓',
  },
  history: {
    system_automatic_send: 'システム自動送信',
  },
  required: '※必須',
  any: '任意',
  required_message: '{attribute} は必須です。',
  search: {
    all: 'すべて',
  },
  yes: 'はい',
  no: 'いいえ',
  unit: {
    yen: '円',
    ton: 't',
    year: '年',
    birth_year: '年生',
    ha: 'ha',
    meter: 'm',
    cubic_meter: '㎥',
    cubic_meters_per_hectare: '㎥/ha',
  },
  pagination: {
    default_text: '1ページ目',
    proceed: 'に進む',
  },
  modal: {
    confirm_explain: '削除する場合は以下のボックスに「削除」と入力した上で削除ボタンを選択してください。',
    delete: '削除する',
    cancel: 'キャンセル',
    deletion: '削除',
    create: '追加する',
    update: '更新する',
  },
  date_time: {
    date_selection: '日付の選択',
  },
  chart: {
    no_data: '登録情報がありません。',
  },
  button_upload: 'ファイルを選択する',
  problem_has_occurred: '問題が発生しました。',
  no_data: '登録情報がありません。',
}

export default lang
